import { ContentAlignment } from '@wix/communities-blog-client-common';

export const getContentAlignmentStyles = (contentAlignment, isRTL) => {
  switch (contentAlignment) {
    case ContentAlignment.Center:
      return 'center';
    case ContentAlignment.Right:
      return isRTL ? 'start' : 'end';
    case ContentAlignment.Left:
    default:
      return isRTL ? 'end' : 'start';
  }
};
